var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3d",
    "data-name": " 3d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art",
    className: "themeSVGStroke themeSVGStrokeHover"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    id: "Path_10662",
    "data-name": "Path 10662",
    d: "M28.9,24a15,15,0,1,1,1.77-12",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M27.14,23l2.7-.79.76,2.68Zm2.78,1.07-.34-1.17-1.18.34Z",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3D-2",
    "data-name": " 3D-2",
    className: "themeSVGStroke themeSVGStrokeHover"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M20,19.92H17.44v-8H20a3.7,3.7,0,0,1,3.49,3.9h0V16A3.57,3.57,0,0,1,20.3,19.9Z",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M12.25,15.55a2.37,2.37,0,0,1,1.67,2.22,2.41,2.41,0,0,1-2.49,2.33h0a2.43,2.43,0,0,1-2.49-2.33h0a3.11,3.11,0,0,1,0-.61",
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M10.78,15.59h.6a2.91,2.91,0,0,1,.83.11",
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M12.82,15a2.13,2.13,0,0,1-1.49.61",
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    d: "M9.24,14.33a4.45,4.45,0,0,1,0-.73,2.12,2.12,0,0,1,2.09-1.86,2,2,0,0,1,2.09,1.86,1.93,1.93,0,0,1-.78,1.72",
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1854",
    "data-name": "Rectangle 1854",
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.9f89e30ad40e75f91083f27fa3c52819.svg";
export { ForwardRef as ReactComponent };